export default "__VITE_ASSET__DGyxeOc7__"